import React from 'react';
import { Loader } from '@uplift/ui-v2';
import { VideoCallDrawerContentContainer } from '../../Layout';
import { TimeRange } from '@uplift/types';
import { UpcomingAppointments } from './UpcomingAppointments.component';
import { AvailabilityReview } from './AvailabilityReview.component';
import { SessionDetails } from './SessionDetails.component';


export type InCallSchedulerProps = {
  patientId: string;
  appointmentId: string;
  onClose: () => void;
};


export const InCallScheduler: React.VFC<InCallSchedulerProps> = (props) => {
  const [ eventRange, setEventRange ] = React.useState<TimeRange | null>(null);
  const [ step, setStep ] = React.useState<'upcomingSessions' | 'availabilityReview' | 'sessionDetails'>('upcomingSessions');

  switch (step) {
    case 'upcomingSessions':
      return (
        <VideoCallDrawerContentContainer onClose={props.onClose} title="Upcoming Sessions">
          <React.Suspense fallback={<Loader color="secondary" height="300px" />}>
            <UpcomingAppointments
              patientId={props.patientId}
              appointmentId={props.appointmentId}
              onScheduleSession={() => {
                setStep('availabilityReview');
              }}
            />
          </React.Suspense>
        </VideoCallDrawerContentContainer>
      );
    case 'availabilityReview':
      return (
        <VideoCallDrawerContentContainer onClose={props.onClose} title="Review availability">
          <AvailabilityReview
            date={eventRange?.start}
            onBack={() => {
              setStep('upcomingSessions');
              setEventRange(null);
            }}
            onSessionDetails={(range) => {
              setEventRange(range);
              setStep('sessionDetails');
            }}
          />
        </VideoCallDrawerContentContainer>
      );
    case 'sessionDetails':
      if (!eventRange) {
        return (
          <VideoCallDrawerContentContainer onClose={props.onClose} title="Session details">
            No event range selected
          </VideoCallDrawerContentContainer>
        );
      }
      return (
        <VideoCallDrawerContentContainer onClose={props.onClose} title="Session details">
          <SessionDetails
            patientId={props.patientId}
            eventRange={eventRange}
            onBack={() => {
              setStep('availabilityReview');
            }}
            onSuccess={async () => {
              setStep('upcomingSessions');
              setEventRange(null);
            }}
          />
        </VideoCallDrawerContentContainer>
      );
  }

  return (
    <VideoCallDrawerContentContainer onClose={props.onClose} title="Unknown step">
      Unknown step
    </VideoCallDrawerContentContainer>
  );
};
